import { useField } from 'formik';
import { mask as maskFunction, unMask } from 'remask';
import { useRastreamento } from '@/components/Pages/Rastreamento/Provider';

interface IProps {
  name: string;
  placeholder?: string;
  mask?: string[];
  type?: string;
  className?: string;
}

const Input: React.FC<IProps> = (props): JSX.Element => {
  const [field, meta, helpers] = useField(props);
  const { rastreamentoCPForCNPJ } = useRastreamento();

  const onChange = (event: any) => {
    const originalValue: string = unMask(event.target.value);

    if (props.name === 'cpfOrCnpj') {
      rastreamentoCPForCNPJ(originalValue);
    }

    if (props.mask) {
      return helpers.setValue(maskFunction(originalValue, props.mask));
    }

    return helpers.setValue(originalValue);
  };

  return (
    <>
      <input {...field} {...props} onChange={onChange} />
      {meta.touched && meta.error && <span>{meta.error}</span>}
    </>
  );
};

export default Input;
